import SglContext from "../SglContext";
import sgllogo from "../images/sgllogo.png";
import printer_icon from "../images/printer.png";
import excel_icon from "../images/icon-excel.png";
import {Link , useNavigate} from 'react-router-dom'
import './schedule.css'
const axios = require("axios").default;
const { useState, useEffect, useContext, useRef } = require("react");


//API END POINTS

const copyright_text = process.env.REACT_APP_COPYRIGHT_TEXT;
const credit_text = process.env.REACT_CREDIT_TEXT;
const credit_company = process.env.REACT_CREDIT_COMPANY;
const credit_url = process.env.REACT_CREDIT_URL;

function Schedule(props) { 
  const navigate = useNavigate(); 
  const [show_details, setShowDetails] = useState({});
  const [rings, setRings] = useState([]);
  const [current_show, setCurrentShow] = useState(
    props.homepageschedule?localStorage.getItem("default_show_id"):localStorage.getItem("show_id")
  );
  const [show_days_list, setshowDaysList] = useState([]);
  const [show_date, setShowDate] = useState("00/00/00");
  const [show_display_date, setShowDisplayDate] = useState("00/00/00");
  const [show_display_date_day, setShowDisplayDateDay] = useState("");
  const [show_planned_time, setShowPlannedTime] = useState(false);
  const [show_est_time, setShowEstTime] = useState(true);
  const [total_trips_count, setTotalTripsCount] = useState(0);
  const [live_class_ids, setLiveClassIds] = useState([]);
  const [live_class_groups, setLiveClassGroups] = useState([]);
  const [live_class_numbers, setLiveClassNumbers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [TimeOutCounter, setTimeOutCounter] = useState(0)
  const [TimeOutInterval, setTimeOutInterval] = useState(0)
  const Sgl = useContext(SglContext);
 

  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
     }
    }
    return false;
  };


  useEffect(() => {

    console.log(props.current_show, show_date,TimeOutCounter)
    if(TimeOutInterval) {
      clearInterval(TimeOutInterval);
    }
    let current_date = show_date
    let Interval = setInterval(() => {
      setTimeOutCounter(prevTimeOutCounter => prevTimeOutCounter + 1);
    }, 60000);  
    setTimeOutInterval(Interval);
    if(props.current_show != current_show && props.current_show != 0 && current_show != 0 && !loading) {
      setShowDate('')
      updateSearchParam( 'date' , '' )
      updateSearchParam( 'sid' , '' )
      current_date = ''
    }
    if (loading) {
      current_date = getQueryVariable("date") ? getQueryVariable("date"): "00/00/00"
      setShowDate(current_date);
    }

    getScheduleData(current_date, props.current_show);
  }, [props.current_show, show_date,TimeOutCounter]);

  const getScheduleData = (show_date, show) => {
    axios
      .get(Sgl.nestApiUrl + "/schedule", {
        params: {
          date: show_date,
          show_id: show,
          customer_id: Sgl.company_id,
        },
      })
      .then((res) => {
        setShowDetails(res.data.show);
        setRings(res.data.rings);
        setCurrentShow(show);
        setshowDaysList(res.data.show_days_list);
        if(show_date != res.data.show_date) {
          setShowDate(res.data.show_date);
          updateSearchParam( 'date' , res.data.show_date )
        }
        updateSearchParam( 'sid' , res.data.show.show_id )
        setShowPlannedTime(res.data.show_planned_time);
        setShowEstTime(res.data.show_est_time);
        setShowDisplayDate(res.data.show_display_date);
        setShowDisplayDateDay(res.data.show_display_date_day);
        setTotalTripsCount(res.data.total_trips_count);
        setLoading(false);

        getLiveClasses();
        document.title =
          "Show Schedule for " +
          show_details.show_name +
          " (" +
          show_display_date +
          ")";
        Sgl.reportToGA(
          "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
            "/" +
            res.data.show.show_id +
            "/schedule/show/" +
            res.data.show_date
        );
        Sgl.reportToFB(
          "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
            "/" +
            res.data.show.show_id +
            "/schedule/show/" +
            res.data.show_date
        );
      });
  };

  const getLiveClasses = () => {
    var timestamp = Date.now();
    axios
      .post(
        Sgl.sglApiUrl +
          "/iphone.php/" +
          Sgl.company_urlpath +
          "/webservice/LiveScoreWidget",
        {
          datetimestamp: timestamp,
          customer_id: Sgl.company_id,
          from_wp_api: true,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        var live_class_ids = [];
        var live_class_numbers = [];
        var live_class_groups = [];

        if (Object.keys(res.data).length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            var show_data = res.data[i];
            // const live_rings = show_data["live_data"];
            const rings = Object.keys(res.data[i]["live_data"]);
            if (
              rings &&
              rings.length > 0 &&
              show_data.show_id == props.current_show
            ) {
              rings.forEach((key, index) => {
                let ring = res.data[i]["live_data"][key];
                if (ring.livenow && ring.livenow.length > 0) {
                  ring.livenow.forEach((class_group, index) => {
                    if (class_group.is_live) {
                      var live_data = {
                        class_group_id: class_group.class_group_id,
                        classes: class_group.classNumbers,
                      };
                      live_class_ids = live_class_ids.concat(
                        class_group.classes
                      );
                      live_class_numbers = live_class_numbers.concat(
                        class_group.classNumbers
                      );
                      live_class_groups.push(live_data);
                    }
                  });
                }
              });
            }
          }
        }
        // setState({
        //   live_class_ids: live_class_ids,
        //   live_class_numbers: live_class_numbers,
        //   live_class_groups: live_class_groups,
        // });
        setLiveClassIds(live_class_ids);
        setLiveClassNumbers(live_class_numbers);
        setLiveClassGroups(live_class_groups);
      });
  };

  const checkIsLive = (class_group_id, class_nums) => {
    var class_group = live_class_groups.find(
      (c) => parseInt(c.class_group_id) === class_group_id
    );
    var class_number_list = class_nums.split(",");
    if (class_group) {
      return class_group.classes.some((item) =>
        class_number_list.includes(item)
      );
    }
    return false;
  };

  const updateSearchParam = ( paramkey , paramValue ) => {
    if(props.homepageschedule) {
      return
    }
    if ( !paramkey ) {
      return
    }

    var searchParams = new URLSearchParams(window.location.search)
    if ( paramValue == '' ) {
      searchParams.delete( paramkey )
    } else {
      searchParams.set( paramkey, paramValue)
    }
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    window.history.pushState(null, '', newRelativePathQuery);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
      canonical.href = window.location.href;
    }
  }


  const openTab = (tabName) => (e) => {
    updateSearchParam( 'date' , tabName )
    var i, tablinks;

    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    e.currentTarget.className += " active";
    setShowDate(e.currentTarget.id)
    setTimeOutCounter(prevTimeOutCounter => prevTimeOutCounter + 1);
  };
  const format_time = (timeString) => {
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = H < 12 || H === 24 ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  };

  const exportToExcel = () => {
    window.open(
      Sgl.sglApiUrl +
        "/iphone.php/" +
        Sgl.company_urlpath +
        "/webservice/ExportToExcel" +
        "/showid/" +
        show_details.show_id +
        "/date/" +
        show_date +
        "/excel_export/1",
      "_blank" // <- This is what makes it open in a new window.
    );
  };

  // render() {
  //   const loading = loading;
  //   if (loading) {
  //     return null;
  //   }

  return (
    <div className="section-to-print schedulecss">
      {/* <ShowPicker
          shows_list={shows_list}
          onShowChange={onShowChange}
          current_show={current_show}
          userData={
            userData}
          ref={ShowPickerElement}
        /> */}
    <section className="search-area">
      {show_details.show_name && (
        <h2 className="sgl-h2">
          Show Schedule for {show_details.show_name} ({show_display_date})
        </h2>
      )}
      <div className="credit-text">
        {credit_text} <a href={credit_url}>{credit_company}</a>
      </div>
      <br />
      <div className="tab no_print" style={{display:`${props.homepageschedule?"none":"block"}`}}>
        {show_days_list.map((day, index) => {
          const default_tab = show_date === day.date ? " active" : "";
          return (
            // <Tooltip title="Delete">
            <button
              className={["tablinks", "element", default_tab].join(" ")}
              onClick={openTab(day.date)}
              id={day.date}
            >
              {day.day}
              {/* <span className="tooltip">I appear on hover!</span> */}
            </button>
            // </Tooltip>
          );
        })}
        {total_trips_count > 0 && (
          <>
            <a className="result_print" onClick={() => window.print()}>
              <img className="printer-icon" src={printer_icon} /> Print
            </a>
            <a className="result_print" onClick={() => exportToExcel()}>
              <img className="printer-icon" src={excel_icon} /> Export
            </a>
          </>
        )}
      </div>
      {total_trips_count > 0 ? (
        <div className="div-responsive">
          {rings.map((ring, index) => {
            return (
              <table className="table narrow-table">
                <thead className="classes-header">
                  <tr className="sgl-primary-header">
                    <th colSpan="3" align="center">
                      {ring.ring_name}{" "}
                      {ring.ring_status
                        ? "(" + ring.ring_status + ")"
                        : ""}
                    </th>
                  </tr>
                </thead>
                {ring.classes.length > 0 ? (
                  <tbody>
                    <tr className="sgl-secondary-header">
                      <th width="70%" style={{ min_width: "30px" }}>
                        Class
                      </th>
                      {(show_est_time || show_planned_time) && (
                        <th
                          width="15%"
                          className="center-align"
                          style={{ min_width: "30px" }}
                        >
                          Est. Start
                        </th>
                      )}
                      <th
                        width="15%"
                        className="center-align"
                        style={{ min_width: "30px" }}
                      >
                        Entries
                      </th>
                    </tr>
                    {ring.classes.map((data, index) => {
                      let sglAnchor =
                        data.warmup_class == 1 || data.group_has_warmup
                          ? ""
                          : "sgl-anchor";
                      let vb_firstClassOfGroup =
                        index == 0 ||
                        ring.classes[index - 1].class_group_id !==
                          data.class_group_id;
                      let vb_GroupWithSingleClass = false;
                      let vb_lastClassOfGroup = false;
                      let vb_isClassGroupLive = false;
                      let class_group_trips = 0;

                      if (vb_firstClassOfGroup) {
                        vb_isClassGroupLive = checkIsLive( data.class_group_id, data.class_list)

                        //Calculate trips of class group
                        for (
                          let vl_class_counter = index;
                          vl_class_counter < ring.classes.length;
                          vl_class_counter++
                        ) {
                          if (
                            data.class_group_id ==
                            ring.classes[vl_class_counter].class_group_id
                          ) {
                            //Same class group
                            if (
                              ring.classes[vl_class_counter]
                                .show_total_trips
                            ) {
                              class_group_trips +=
                                ring.classes[vl_class_counter].total_trips;
                            }
                          } else {
                            //Different class group
                            break;
                          }
                        }

                        //Check if class group has only single class
                        if (
                          index >= ring.classes.length - 1 ||
                          data.class_group_id !=
                            ring.classes[index + 1].class_group_id
                        ) {
                          vb_GroupWithSingleClass = true;
                        }
                      }

                      if (
                        vb_GroupWithSingleClass ||
                        index >= ring.classes.length - 1 ||
                        data.class_group_id !=
                          ring.classes[index + 1].class_group_id
                      ) {
                        vb_lastClassOfGroup = true;
                      }

                      return (
                        <>
                          {vb_firstClassOfGroup && (
                            <tr
                              className={[
                                vb_GroupWithSingleClass
                                  ? sglAnchor +
                                    " sgl-anchor-hover bottom-bordered-row"
                                  : "",
                                "class_group_row",
                              ].join(" ")}
                            >
                              <td>
                                <Link
                                  className="list-schedule"
                                  to ={
                                   ((vb_GroupWithSingleClass || vb_isClassGroupLive) &&
                                    !data.schedule_break) 
                                      ?"/classes/detail?cid=" +
                                        data.class_id +
                                        "&sid=" +
                                        props.current_show +
                                        "&cgid=" +
                                        data.class_group_id +
                                        "&ring=" +
                                        ring.ring_number
                                      : "#"
                                  }
                                >
                                  {data.group_name}{" "}
                                  {!data.schedule_break
                                    ? "[" + data.class_list + "]"
                                    : ""}{" "}
                                  &nbsp;
                                  {data.sponsor.trim() && (
                                    <span className="sponsor_text">
                                      (Sponsored By: {data.sponsor.trim()})
                                    </span>
                                  )}
                                  &nbsp;
                                  {vb_isClassGroupLive ? (
                                    <span className="live_class_badge">Live</span>
                                  ) : (
                                    ""
                                  )}
                                </Link>
                              </td>
                              {(show_planned_time && (
                                <td className="center-align">
                                  <Link
                                    className="list-schedule"
                                    to ={
                                      vb_GroupWithSingleClass &&
                                      !data.schedule_break
                                        ?"/classes/detail?cid=" +
                                          data.class_id +
                                          "&sid=" +
                                          props.current_show +
                                          "&cgid=" +
                                          data.class_group_id +
                                          "&ring=" +
                                          ring.ring_number
                                        : "#"
                                    }
                                  >
                                    {data.start_time_default !== "00:00:00"
                                      ? format_time(data.start_time_default)
                                      : ""}
                                  </Link>
                                </td>
                              )) ||
                                (show_est_time && (
                                  <td className="center-align">
                                    <Link
                                      className="list-schedule"
                                      to ={
                                        vb_GroupWithSingleClass &&
                                        !data.schedule_break
                                          ? "/classes/detail?cid=" +
                                            data.class_id +
                                            "&sid=" +
                                            props.current_show +
                                            "&cgid=" +
                                            data.class_group_id +
                                            "&ring=" +
                                            ring.ring_number
                                          : "#"
                                      }
                                    >
                                      {data.estimated_start_time !== "00:00:00"
                                        ? format_time(data.estimated_start_time)
                                        : ""}
                                    </Link>
                                  </td>
                                ))}
                              <td className="center-align">
                                <Link
                                  className="list-schedule"
                                  to ={
                                    vb_GroupWithSingleClass &&
                                    !data.schedule_break
                                      ? "/classes/detail?cid=" +
                                        data.class_id +
                                        "&sid=" +
                                        props.current_show +
                                        "&cgid=" +
                                        data.class_group_id +
                                        "&ring=" +
                                        ring.ring_number
                                      : "#"
                                  }
                                >
                                  {class_group_trips}
                                </Link>
                              </td>
                            </tr>
                          )}

                          {!vb_GroupWithSingleClass && (
                            <tr
                            onClick={(e) => { e.preventDefault(); 
                              navigate('/classes/detail?cid=' +
                                        data.class_id +
                                        "&sid=" +
                                        props.current_show +
                                        "&cgid=" +
                                        data.class_group_id +
                                        "&ring=" +
                                        ring.ring_number) 
                                      }}
    
                              className={[
                                "sgl-anchor-hover",
                                vb_lastClassOfGroup
                                  ? "bottom-bordered-row"
                                  : "",
                              ].join(" ")}
                            >
                              <td
                                colSpan={
                                  show_est_time || show_planned_time ? "2" : "1"
                                }
                                className="grouped_class"
                              >
                                <a>
                                  {data.class_number} - {data.class_name}
                                  {data.cancelled ? " (CANCELLED)" : ""}
                                  {data.is_open_card_warmup
                                    ? " [OPEN CARD]"
                                    : ""}{" "}
                                  &nbsp;
                                  {data.sponsor.trim() && (
                                    <span className="sponsor_text">
                                      (Sponsored By: {data.sponsor.trim()})
                                    </span>
                                  )}
                                  {/* &nbsp;{((checkIsLive(data.class_id)) ? <span className='live_class_badge'>Live</span>:"")} */}
                                </a>
                              </td>
                              <td className={["center-align"].join(" ")}>
                                <a>
                                  {data.show_total_trips
                                    ? data.total_trips
                                    : ""}
                                </a>
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                    <tr className="sgl-anchor">
                      <td>
                        <b>Total Trips</b>
                      </td>
                      {(show_est_time || show_planned_time) && <td></td>}
                      <td className="center-align totaltrips">
                        {ring.total_trips}
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td>No classes scheduled.</td>
                    </tr>
                  </tbody>
                )}
              </table>
            );
          })}
        </div>
      ) : (
        <div id="no_trip_msg">
          <span>No trips scheduled for {show_display_date_day}</span>
        </div>
      )}
      <div id="print_footer" className="print_block print_footer">
        <span>
          <img className="footer_logo" src={sgllogo} />
          Copyright © {(new Date().getFullYear())} · All rights reserved · ShowGrounds, LLC. · Shelburne
          Falls MA · 1-888-429-9495
        </span>
      </div>
      <div className="copyright-text no_print">{copyright_text}</div>
      </section>
    </div>
  );
}
// }
export default Schedule;
// ReactDOM.render(<Schedule />, document.getElementById("sgl-content-wrapper"));
